import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {IDataPartner, IMapas} from "../../../types";
import {Paper, Typography} from "@material-ui/core";


interface IProps {
    indexClient: number
    partnerData: IDataPartner
    lastConnections: Record<string, string>
    setUserSelectedIndex(index: number | null): void
}

interface Istate {
    tipo: string
    superficie: number
    parcelas: number
    hover: boolean
}


class Client extends React.Component<IProps, Istate> {

    state:Istate = {
        tipo: "",
        superficie: 0,
        parcelas: 0,
        hover: false,
    }

    componentDidMount() {
        if (!this.props.partnerData.hasOwnProperty("users")) {
            setTimeout(() => this.componentDidMount(), 200)
            return
        }
        let tipo = "Otro"
        if (this.props.partnerData.users[this.props.indexClient]["level"] === 1) tipo = "Básico"
        if (this.props.partnerData.users[this.props.indexClient]["level"] === 2) tipo = "Avanzado"
        if (this.props.partnerData.users[this.props.indexClient]["level"] === 3) tipo = "Profesional"

        this.setState({tipo: tipo})

        let parcelas = this.props.partnerData.plots[this.props.partnerData.users[this.props.indexClient]["nombre"]].length
        let superficie = 0

        for (let i = 0; i < parcelas; i++) {
            superficie += this.props.partnerData.plots[this.props.partnerData.users[this.props.indexClient]["nombre"]][i]["superficie"] as number
        }


        this.setState({
            parcelas: parcelas,
            superficie: superficie
        })
    }


    render() {
        return (
            <Paper
                elevation={this.state.hover? 10 : 0}
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    height: '100%',
                    backgroundColor: "white",
                    borderRadius: 20,
                    cursor: "pointer"
                }}
                onMouseEnter={() => this.setState({hover: true})}
                onMouseLeave={() => this.setState({hover: false})}
                onClick={() => this.props.setUserSelectedIndex(this.props.indexClient)}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "60%",
                        height: "100%"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            height: 'calc(100% - 30px)'
                        }}
                    >
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                marginLeft: 30,
                                marginTop: 20,
                                fontSize: 14
                            }}
                        >
                            {this.props.partnerData.users[this.props.indexClient]["nombre"]}
                        </Typography>

                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontWeight: "bold",
                                marginLeft: 30,
                                marginTop: 5,
                                fontSize: 14
                            }}
                        >
                            {this.props.partnerData.users[this.props.indexClient]["limite_ha"] === -1 ?
                                "Ilim. Ha" + ", "
                                :
                                this.props.partnerData.users[this.props.indexClient]["limite_ha"] + " Ha" + ", "
                            }

                            {this.props.partnerData.users[this.props.indexClient]["limite_parcelas"] === -1 ?
                                "Ilim. Parcelas"
                                :
                                this.props.partnerData.users[this.props.indexClient]["limite_parcelas"] + " parcelas"
                            }

                        </Typography>

                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                marginLeft: 30,
                                marginTop: 5,
                                fontSize: 14
                            }}
                        >
                            {Math.round(this.state.superficie/100)/100 + " Ha" + ", " + this.state.parcelas + " parcelas"}
                        </Typography>

                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            height: 30
                        }}
                    >
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                marginLeft: 30,
                                fontSize: 14
                            }}
                        >
                            {this.state.tipo}
                        </Typography>
                    </div>

                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "40%",
                        height: "100%"
                    }}
                >

                    <Typography
                        style={{
                            fontFamily: "Poppins",
                            marginTop: 20,
                            fontSize: 14
                        }}
                    >
                        {"ini: " +
                            (this.props.partnerData.users[this.props.indexClient]["fecha_creacion"] as string)
                                .replace(/-/gi, '/')
                        }
                    </Typography>

                    <Typography
                        style={{
                            fontFamily: "Poppins",
                            marginTop: 5,
                            fontSize: 14
                        }}
                    >
                        {"ult: " +
                            this.props.lastConnections[this.props.partnerData.users[this.props.indexClient]["nombre"]]
                        }
                    </Typography>

                    <Typography
                        style={{
                            fontFamily: "Poppins",
                            marginTop: 5,
                            fontSize: 14
                        }}
                    >
                        {"fin: " +
                            (this.props.partnerData.users[this.props.indexClient]["fecha_caducidad"] as string)
                                .replace(/-/gi, '/')
                        }
                    </Typography>

                </div>

            </Paper>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    partnerData: state.partner.dataPartner,
    lastConnections: state.partner.lastConnections
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setUserSelectedIndex: (index: number | null) => dispatch({type: "set-user-selected-index", index}),
});

export default connect(mapStateToProps, mapDispatchToProps)(Client);
